import { Link } from "react-router-dom";
import { Facebook } from "lucide-react";
import { CONTACT } from "../lib/content";
import Triskelion from "./Triskelion";

const COLS = [
  {
    title: "Shop",
    links: [
      ["Sourced Jewellery", "/shop/jewellery"],
      ["Collections", "/collections"],
      ["Celtic Jewellery", "/shop/celtic"],
      ["Men's", "/shop/mens"],
      ["Lab Grown", "/shop/lab-grown"],
      ["Vouchers", "/shop/vouchers"],
      ["More In Store", "/more-in-store"],
    ],
  },
  {
    title: "Services",
    links: [
      ["Bespoke Jewellery", "/bespoke"],
      ["Jewellery Repairs", "/services"],
      ["Remodelling", "/services"],
      ["Valuations", "/services"],
      ["Cleaning", "/services"],
      ["Polishing", "/services"],
      ["Rhodium Plating", "/services"],
      ["Engraving", "/services"],
    ],
  },
  {
    title: "About",
    links: [
      ["About Celtic Gold", "/about"],
      ["Meet the Team", "/about#team"],
      ["Our Jewellers", "/about#jewellers"],
      ["Latest News", "/news"],
    ],
  },
  {
    title: "Customer Information",
    links: [
      ["Delivery & Shipping", "/shipping"],
      ["Terms & Conditions", "/terms"],
      ["Returns & Exchanges", "/terms#returns"],
      ["Ring Sizing", "/terms#ring-sizing"],
      ["Blue Light & Veterans Discount", "/#discounts"],
      ["Contact", "/contact"],
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-gold/15 bg-[#080D17]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <Triskelion className="w-9 h-9 text-gold" />
              <span className="font-serif text-2xl text-ivory">
                Celtic <span className="text-gold">Gold</span>
              </span>
            </Link>
            <p className="text-stone-mist text-sm leading-relaxed max-w-xs">
              Manx, Celtic and Archibald Knox-inspired jewellery from the Isle of Man. Family-run since 1982, with a
              fully equipped workshop in Peel.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href="https://www.facebook.com/Celtic-Gold-110755035678465"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Celtic Gold on Facebook"
                data-testid="social-facebook"
                className="w-10 h-10 border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-ink transition-colors duration-300"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>
            <div className="mt-8 space-y-3 text-sm">
              <p className="text-ivory/80">
                {CONTACT.address.map((l, i) => (
                  <span key={i} className="block">{l}</span>
                ))}
              </p>
              <a href={`tel:${CONTACT.phoneShort.replace(/\s/g, "")}`} className="block text-gold hover:text-gold-glow transition-colors" data-testid="footer-phone">
                {CONTACT.phone}
              </a>
              <a href={`mailto:${CONTACT.email}`} className="block text-gold hover:text-gold-glow transition-colors" data-testid="footer-email">
                {CONTACT.email}
              </a>
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h3 className="text-xs uppercase tracking-[0.25em] text-gold mb-5 font-medium">{col.title}</h3>
              <ul className="space-y-2.5">
                {col.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="text-stone-mist text-sm hover:text-ivory transition-colors duration-300" data-testid={`footer-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-stone-mist font-mono tracking-wider">
            © {new Date().getFullYear()} Celtic Gold Ltd · Est. 1982 · Peel, Isle of Man
          </p>
          <Triskelion className="w-5 h-5 text-gold/50 animate-spin-slow" strokeWidth={9} />
        </div>
      </div>
    </footer>
  );
}
